export default `
mutation subProduto(
    $idProposta: String
    $subProdutoId: String
    $subProdutoDesc: String
    $tagEmMaos: Boolean
    $quantidadeIdentificadores: String
    $tipoProduto: String
    $comoUsar: String
    $captchaResponse: String
    $placa: String
    $categoriaVeiculo: String
    $categoriaEixo: String
  ) {
    subProdutoFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse
        categoriaVeiculo: $categoriaVeiculo
        categoriaEixo: $categoriaEixo
        placa: $placa
        pedido: {
          comoUsar:$comoUsar
          produtos: [
            {
              subProdutoId:$subProdutoId
              subProdutoDesc: $subProdutoDesc
              tagEmMaos: $tagEmMaos
              tipoProduto: $tipoProduto
              quantidadeIdentificadores: $quantidadeIdentificadores
            }
          ]
        }
      }
    ) {
      dados {
        id
        situacaoProposta
        reprovadoAnaliseCredito
        planoPos
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
